import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
import { FunctionComponent } from "react";
import styles from "./hamburgerMenu.module.scss";
import { Modal } from "@material-ui/core";
import Home from "pages/Home";

const HamburgerMenu: FunctionComponent<{
  className?: string;
  isHamburgerMenuOpen: boolean;
  setIsHamburgerMenuOpen: (newState: boolean) => void;
}> = ({ className, isHamburgerMenuOpen, setIsHamburgerMenuOpen }) => {
  const toggleMenu = () => {
    setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
  };

  return (
    <>
      <button
        className={`${className} ${styles.menuButton}`}
        onClick={toggleMenu}
      >
        <Menu fontSize={"large"}></Menu>
      </button>
      <Modal
        open={isHamburgerMenuOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={styles.modalContent}>
          <button
            onClick={toggleMenu}
            className={`${className} ${styles.menuButton}`}
          >
            <Close fontSize={"large"}></Close>
          </button>
          <Home isHomePage fromHamburger />
        </div>
      </Modal>
    </>
  );
};
export default HamburgerMenu;
